export const titleHeight = 60;

export const questionTitleHeight = 32;

export const getOptionsClass = questionsLength => questionsLength > 5 ? 'col2' : '';



// WEBPACK FOOTER //
// ./src/components/ActionMode/constants.js